"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertBaseColorStyleName = exports.ColorMap = exports.AlertType = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var AlertType;
(function (AlertType) {
    AlertType["Success"] = "success";
    AlertType["Info"] = "info";
    AlertType["Warning"] = "warning";
    AlertType["Error"] = "error";
})(AlertType = exports.AlertType || (exports.AlertType = {}));
exports.ColorMap = {
    success: {
        accentColor: '#91db8b',
        borderColor: '#22683e',
        backgroundColor: '#cdefc4',
        hoverColor: '#91db8b',
    },
    info: {
        accentColor: '#90d0fe',
        borderColor: '#05628a',
        backgroundColor: '#cfe9fe',
        hoverColor: '#90d0fe',
    },
    warning: {
        accentColor: '#fcc003',
        borderColor: '#6f3400',
        backgroundColor: '#f9e3b6',
        hoverColor: '#fcc003',
    },
    error: {
        accentColor: '#feb8ab',
        borderColor: '#ba0517',
        backgroundColor: '#feded8',
        hoverColor: '#feb8ab',
    },
};
exports.AlertBaseColorStyleName = TypeStyle.style({
    $nest: (_a = {},
        _a["&." + AlertType.Success] = {
            backgroundColor: exports.ColorMap.success.backgroundColor,
            borderColor: exports.ColorMap.success.borderColor,
        },
        _a["&." + AlertType.Info] = {
            backgroundColor: exports.ColorMap.info.backgroundColor,
            borderColor: exports.ColorMap.info.borderColor,
        },
        _a["&." + AlertType.Warning] = {
            backgroundColor: exports.ColorMap.warning.backgroundColor,
            borderColor: exports.ColorMap.warning.borderColor,
        },
        _a["&." + AlertType.Error] = {
            backgroundColor: exports.ColorMap.error.backgroundColor,
            borderColor: exports.ColorMap.error.borderColor,
        },
        _a)
});
//# sourceMappingURL=AlertStyles.js.map